import { RUNNING_ENVIRONMENT } from '../../../config/env';
import { eEnv } from '../../../constants';
import { buildMsalAuthConfig } from '../buildMsalAuthConfig';

const msalAuthDevConfig = (cacheLocation: string) => buildMsalAuthConfig(
  '8feecb5f-ba5b-43d5-b718-45252f21c1b8',
  'https://estiworlddev.b2clogin.com/estiworlddev.onmicrosoft.com/B2C_1A_SMART_HRD_SUSI2',
  ['estiworlddev.b2clogin.com'],
  cacheLocation,
);

const msalAuthTestConfig = (cacheLocation: string) => buildMsalAuthConfig(
  '4144f1f3-3900-4c88-ad75-34b0a65a18b5',
  'https://estiworldtest2.b2clogin.com/estiworldtest2.onmicrosoft.com/B2C_1A_SMART_HRD_SUSI2',
  ['estiworldtest2.b2clogin.com'],
  cacheLocation,
);
const msalAuthStageConfig = (cacheLocation: string) => buildMsalAuthConfig(
  'b3ad1984-78d3-495e-8446-478c6a0b7ad5',
  'https://estiworldstage.b2clogin.com/estiworldstage.onmicrosoft.com/B2C_1A_SMART_HRD_SUSI2',
  ['estiworldstage.b2clogin.com'],
  cacheLocation,
);

const msalAuthProdConfig = (cacheLocation: string) => buildMsalAuthConfig(
  '6dae84cb-07da-4ed2-b6ae-99d49bbf14a0',
  'https://estimationworld.b2clogin.com/estimationworld.onmicrosoft.com/B2C_1A_SMART_HRD_SUSI2',
  ['estimationworld.b2clogin.com'],
  cacheLocation,
);

export const msalAuthConfig = (cacheLocation: string) => {
  switch (RUNNING_ENVIRONMENT) {
    case eEnv.LOCAL:
    case eEnv.DEV:
      return msalAuthDevConfig(cacheLocation);

    case eEnv.TEST:
      return msalAuthTestConfig(cacheLocation);

    case eEnv.STAGE:
      return msalAuthStageConfig(cacheLocation);

    case eEnv.PROD:
      return msalAuthProdConfig(cacheLocation);

    default:
      throw new Error(`Unknown environment: ${RUNNING_ENVIRONMENT}`);
  }
};
